'use client';

import { trackConversion } from '../../../../../utils/conversion/trackConversion';
import { buildMetaConversion } from './buildMetaConversion';
import { buildGoogleAdsConversion } from './buildGoogleAdsConversion';
import type { GoogleAdsTrackingConfig, MetaTrackingConfig } from './types';

interface Args {
  formId?: string;
  /** Formatted submission values - what the placeholders resolve against. */
  values: Record<string, string>;
  metaTracking?: MetaTrackingConfig;
  googleAdsTracking?: GoogleAdsTrackingConfig;
  googleAdsId?: string;
}

function extractEmail(values: Record<string, string>): string | undefined {
  return Object.values(values).find(
    (value) => typeof value === 'string' && value.includes('@'),
  );
}

/**
 * Await this before navigating away: the browser events only fire once the
 * platform has had its say on the submission, and a redirect in between would
 * cut that short.
 */
export async function fireConversion({
  formId,
  values,
  metaTracking,
  googleAdsTracking,
  googleAdsId,
}: Args): Promise<void> {
  const meta = buildMetaConversion({ config: metaTracking, values });
  const googleAds = buildGoogleAdsConversion({
    config: googleAdsTracking,
    googleAdsId,
    values,
  });

  if (!meta && !googleAds) return;

  await trackConversion({
    formId,
    formValues: values,
    email: extractEmail(values),
    meta,
    googleAds,
  });
}
